const cleanModeOptionsSchema = [
	{
		name: "positioning",
		label: "General Positioning",
		type: "group",
		items: [
			{
				name: "problem",
				label: "Problem",
				type: "group",
				items: [
					{
						name: "x",
						type: "number",
						default: 0,
					},
					{
						name: "y",
						type: "number",
						default: 24,
					},
				],
			},
			{
				name: "keyboard",
				label: "Keyboard",
				type: "group",
				items: [
					{
						name: "x",
						type: "number",
						default: 0,
					},
					{
						name: "y",
						type: "number",
						default: 17.5,
					},
				],
			},
		],
	},
	{
		name: "appearance",
		label: "General Appearance",
		type: "group",
		items: [
			{
				name: "backgroundColor",
				label: "Background Color",
				type: "color",
				default: "#ffffff",
			},
			{
				name: "engineBG",
				type: "enum",
				enum: ["default", "green", "rect", "none"],
				default: "none",
			},
			{
				name: "solutions",
				type: "enum",
				enum: ["stamp", "green", "white", "skip", "normal"],
				default: "stamp",
			},
		],
	},
	{
		name: "behavior",
		label: "General Behavior",
		type: "group",
		items: [
			{
				name: "suppressSomeMouseEvents",
				type: "boolean",
				default: false,
				help: `Suppresses onMouseEnter, onMouseMove, and onMouseLeave events to help with some touch screen issues we've seen on certain engines (TEMPORARY - should be removed once we fix said engines)`,
			},
		],
	},
	{
		name: "stamp",
		label: "Stamp",
		type: "group",
		items: [
			{
				name: "variant",
				type: "enum",
				enum: ["stars", "rect", "roundrect", "underline", "ellipse", "random"],
				default: "random",
			},
			{
				name: "time",
				type: "number",
				default: 0.5,
			},
			{
				name: "size",
				type: "number",
				default: 0.4,
			},
			{
				name: "skipDelay",
				type: "number",
				default: 1,
			},
			{
				name: "minAngle",
				type: "number",
				default: -15,
			},
			{
				name: "maxAngle",
				type: "number",
				default: 8,
			},
			{
				name: "minRotationAmount",
				type: "number",
				default: 2,
			},
			{
				name: "maxRotationAmount",
				type: "number",
				default: 10,
			},
			{
				name: "x",
				type: "number",
				default: 0,
			},
			{
				name: "y",
				type: "number",
				default: 20,
			},
		],
	},
	{
		name: "misc",
		label: "Miscellaneous",
		type: "group",
		items: [
			{
				name: "hideDrawTools",
				type: "boolean",
				default: true,
			},
			{
				name: "hideCopyright",
				type: "boolean",
				default: true,
			},
			{
				name: "correctColor",
				type: "color",
				default: "#000000",
			},
			{
				name: "bubbles",
				label: "Problem Bubbles",
				type: "group",
				items: [
					{
						name: "show",
						type: "boolean",
						default: false,
					},
					{
						name: "x",
						type: "number",
						default: 0,
					},
					{
						name: "y",
						type: "number",
						default: 40,
					},
				],
			},
		],
	},
];

module.exports = {cleanModeOptionsSchema};
